import * as React from 'react';

/**
 * React 18's `useDeferredValue`. The project's @types/react is still v17, which does not declare
 * it, so it is read off the module; an identity fallback keeps it safe.
 */
export const useDeferredValue: <T>(value: T) => T =
  (React as any).useDeferredValue ?? (<T,>(value: T) => value);
